import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const Root = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
}));

interface ContainerProps {
  children: React.ReactNode;
  maxWidth?: number;
}

const Container = ({ children, maxWidth }: ContainerProps) => (
  <Root>
    <Box
      sx={{
        mx: 1,
        my: 2,
        width: "100%",
        maxWidth,
      }}
    >
      {children}
    </Box>
  </Root>
);

export default Container;
